<div id="ngx-datatable" class="page-layout simple fullwidth">
  <!-- HEADER -->
  <!-- <div class="header mat-accent-bg p-12 p-sm-24 thin-header" fxLayout="column" fxLayoutAlign="start start"
    fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

    <div fxFlex="" fxLayoutAlign="start center">
      <mat-icon class="logo-icon" *eguardIfOnDom>person</mat-icon>&nbsp;&nbsp;
      <span class="logo-text h1">Users </span>
    </div>
  </div> -->

  <!-- <input
        type='text'
        style='padding:8px;margin:15px auto;width:30%;'
        placeholder='Search Name '
        (keyup)='updateFilter($event)'
      /> -->

  <mat-progress-bar *ngIf="loadingIndicator" mode="query" class="my-color" mode="query" value="value"
    [bufferValue]="bufferValue"></mat-progress-bar>

  <div class="addUser">
    <button mat-raised-button color="accent" (click)="addUser()">
      <mat-icon>person_add</mat-icon>
      ADD
    </button>
  </div>
  <!-- <div class="add-user-button">
    <button mat-fab class=" mat-warn" aria-label="Add event" (click)="addUser()" tooltip="Add Users">
      <mat-icon class="add">add</mat-icon>
    </button>
  </div> -->
  <!-- / HEADER -->
  <!-- CONTENT -->


  <div class="content p-24">
    <div class="table-header">
      <mat-form-field>
        <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search any user">
      </mat-form-field>
    </div>
    <mat-table [dataSource]="rows">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-button color="accent" (click)="userDetails(element)" style="margin-left: 0px">
            {{element.first_name || 'Open'}} {{element.last_name}} 
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.email }} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef> Role </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.role}} </mat-cell>
      </ng-container>
      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{element.status}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-icon-button class="" matTooltip="Delete User" (click)="deleteUser(element)">
            <mat-icon>delete</mat-icon>
          </a>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayColumns;"></mat-row>
    </mat-table>
    <mat-paginator #paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 50]" [showFirstLastButtons]="true">
    </mat-paginator>


  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/users/clerk-users.component.html